var cov_m89jwsqjy = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Menu/index.ts",
      hash = "f75e17779fe0aabbd04083ba3ce56c2a3ae921ca",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Menu/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 0
        },
        end: {
          line: 3,
          column: 33
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Root from './Root';
cov_m89jwsqjy.s[0]++;
Root.displayName = 'ShineoutMenu';
export default Root;